import React, {useState, useMemo, useEffect} from 'react';
import './MyMap.scss';

let count = 0;

export default function Bubble(props) {
    count++;
    //console.log("Bubble render number: ", count);
    const unit = useMemo(() => props.unit, [props.unit])
    const stateData = props.stateData;
    const isSelected = props.isSelected;

    const handleRightClick = (e) => {
        props.setActiveUnit(unit.unit_id)
        props.onContextMenu(e)
    }
    
    const handleClick = (e) => {
        e.stopPropagation()
        props.onUnitSelect(unit.unit_id)
    } 
    const [hover, setHover] = useState(false);
    const x = 10;
    const y = 10;
    const rot = unit.bearing || 0;
    const styles = {
        transform: `translate(${x}px, ${y}px) rotateZ(${rot}deg)`
    };
    const onMouseEnter = () => {
        setHover(true)
    }
    const onMouseLeave = () => {
        setHover(false)
    }

    return (
        <div className="popup-bubble-anchor" id={unit.name} onContextMenu={handleRightClick} onClick={handleClick} style={{cursor: 'pointer'}}>
            <div className={`unit popup-bubble ${isSelected ? 'selected' : ''}`} style={{ zIndex: 1000, border: isSelected ? '3px solid #007bff' : 'none' }}>
                <div><span className="bubble-label" data-locale="ID">ID : </span><span>{unit.unit_id}</span></div>
                <div><span className="bubble-label" data-locale="Name">Name : </span><span>{unit.name}</span></div>
                {/* <div className={`detail ${hover ? '' : 'hidden'}`}  > */}
                <div className={`detail `}  >
                    <div><span className="bubble-label" data-locale="State">State : </span><span>{stateData}</span></div>
                    {/*
                    <div><span data-locale="Type">Type : </span><span></span></div>
                    <div><span data-locale="HWHost">HWHost : </span><span></span></div>
                    <div><span data-locale="OS">OS : </span><span></span></div>
                    <div><span data-locale="CpuUsagePercentage">CpuUsagePercentage : </span><span></span></div>
                    <div><span data-locale="MemoryUsagePercentage">MemoryUsagePercentage : </span><span></span></div>
                    <div><span data-locale="DiskUsagePercentage">DiskUsagePercentage : </span><span></span></div>
                    <div><span data-locale="ProjectPath">ProjectPath : </span><span></span></div>
                    <div><span data-locale="TotalSessions">TotalSessions : </span><span></span></div>
                    <div><span data-locale="TotalTriggers">TotalTriggers : </span><span></span></div>
                    */}
                    <div style={{ marginTop: '8px' }}>
                        <button 
                            className="btn btn-sm btn-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (props.onSessionVideos) {
                                    props.onSessionVideos(unit.unit_id);
                                }
                            }}
                            style={{ fontSize: '12px', padding: '4px 8px' }}
                        >
                            Open sessions
                        </button>
                    </div>
                    <div style={{ marginTop: '8px' }}>
                        <button 
                            className="btn btn-sm btn-primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (props.onOpenUnit) {
                                    props.onOpenUnit(unit.unit_id);
                                }
                            }}
                            style={{ fontSize: '12px', padding: '4px 8px' }}
                        >
                            Open unit
                        </button>
                    </div>
                    <div className="right-click-hint">Right-click for more actions</div>
                </div>
            </div>
            <span className="icon-car" style={{...styles, color: isSelected ? '#007bff' : 'inherit', cursor: 'pointer'}}></span>
        </div>
    )

}